import React, { useEffect, useRef, useState } from 'react'
import { Dropdown } from 'react-bootstrap'
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { Edit, checkedBilledState, unCheckedBilledState, updateSorting, getTimeBilingWorksheetForDatatableAsync } from './timeBillingSlice';
import CustomPagination from "../../../common/Pagination";
import OffCanvas from '../../../common/OffCanvas';
import { Link } from 'react-router-dom';
import moment from 'moment';
/* import { TimeEntryArchiveForm } from './TimeEntryArchiveForm'; */
import { KTIcon } from '../../../_metronic/helpers';
import { ShowSwalWithConfirmation } from '../../../common/SweetAlert';
import { ShowToast } from '../../../common/Toastr';
import clsx from 'clsx';
import { formatDateWithDateAndMonthName, formatDateToTime, getValueFromResource, FormatInvoiceDecimalNumber } from '../../../common/timeLiveFunction';

const itemClass = 'ms-1 ms-lg-0';
const TimeBillingWorksheetItem = (props: any) => {
    const { onhandleFormOnClickEvent, offCanvasObject, t, onopenModal, IsEdit, IsDelete } = props;

    const dispatch = useAppDispatch();
    // const { timeBillingWorksheetList } = useAppSelector((state) => state.timeBillingWorksheet);

    const { timeBillingWorksheetList, search, optionClientNameValue, optionClientNameText, optionProjectValue, optionProjectText,
        optionTaskNameValue, optionTaskNameText, optionBilledValue, startDate, endDate, sortOrder, sortColumn, pageSize
    } = useAppSelector((state) => state.timeBillingWorksheet);
    const { decimalPlaces, cultureInfoName } = useAppSelector((state) => state.globalState);

    // const handleCheckboxChange = (e: any, rowId: any) => {
    //     if (e.target.checked) {
    //         dispatch(checkedBilledState(rowId))
    //     } else {
    //         dispatch(unCheckedBilledState(rowId))
    //     }
    // };


    const [checkedItems, setCheckedItems] = useState<{ [key: string]: boolean }>({});
    // const [hoveredColumn, setHoveredColumn] = useState(null);

    const handleCheckboxChange = (e: any, rowId: any) => {
        const isChecked = e.target.checked;
        setCheckedItems((prev) => ({
            ...prev,
            [rowId]: isChecked,
        }));

        if (isChecked) {
            dispatch(checkedBilledState(rowId));
        } else {
            dispatch(unCheckedBilledState(rowId));
        }
    };

    const isItemChecked = (rowId: any, billed: boolean) => {
        return checkedItems[rowId] !== undefined ? checkedItems[rowId] : billed;
    };

    const onHandleSorting = (sortOrder: string, sortColumn: string) => {
        let objects = {
            "sortOrder": sortOrder,
            "sortColumn": sortColumn,
            "start": 0,
            "pageSize": pageSize,
            "currentPage": 1
        }
        dispatch(updateSorting(objects));
        let SearchParamsValues = `${optionClientNameValue},${optionProjectValue},${optionTaskNameValue},${optionBilledValue},true,${moment(startDate).format('MM-DD-YYYY')},${moment(endDate).format('MM-DD-YYYY')},${optionClientNameText},${optionProjectText},${optionTaskNameText}`;
        dispatch(getTimeBilingWorksheetForDatatableAsync({ currentPage: 1, pageSize: pageSize, start: 0, SearchParamsValues: SearchParamsValues, search: search }));
    }

    // const handleMouseEnter = (columnIndex: any) => {
    //     setHoveredColumn(columnIndex);
    // }

    // const handleMouseLeave = () => {
    //     setHoveredColumn(null);
    // }
    return (
        <>
            <table className="table table-row-bordered  align-middle gs-1 gy-1 gx-1" >
                <thead>
                    <tr className="thHeading align-middle">
                        <th
                            //className='w-25px'
                            style={{ width: '5%' }}>
                                {/* {t('Billed')} */}
                                {getValueFromResource('Billed',dispatch, t)}
                                </th>
                        <th
                            style={{ width: '15%' }}
                        >
                           {getValueFromResource('Date',dispatch, t)}
                            {sortColumn === '1' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("desc", "1") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("asc", "1") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                <><span className="cursor" onClick={() => { onHandleSorting("asc", "1") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleSorting("desc", "1") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                        </th>
                        <th
                            style={{ width: '20%' }}
                        >
                            {getValueFromResource('Employee Name',dispatch, t)}
                            {sortColumn === '2' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("desc", "2") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("asc", "2") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 2 && 
                                <><span className="cursor" onClick={() => { onHandleSorting("asc", "2") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleSorting("desc", "2") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                        </th>
                        <th style={{ width: '20%' }}
                        // onMouseEnter={() => handleMouseEnter(3)}
                        // onMouseLeave={handleMouseLeave}
                        >
                            {/* {t('Task / Project')} */}
                            {getValueFromResource('Task / Project',dispatch, t)}
                            {sortColumn === '3' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("desc", "3") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("asc", "3") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 3 && 
                                <><span className="cursor" onClick={() => { onHandleSorting("asc", "3") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleSorting("desc", "3") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                        </th>
                        <th style={{ width: '15%' }}
                        // onMouseEnter={() => handleMouseEnter(4)}
                        // onMouseLeave={handleMouseLeave}
                        >
                            {/* {t('Invoice Details')} */}
                            {getValueFromResource('Invoice Details',dispatch, t)}
                            {sortColumn === '4' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("desc", "4") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("asc", "4") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 4 && 
                                <><span className="cursor" onClick={() => { onHandleSorting("asc", "4") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleSorting("desc", "4") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                        </th>
                        <th style={{ width: '12%' }}
                        // onMouseEnter={() => handleMouseEnter(5)}
                        // onMouseLeave={handleMouseLeave}
                        >
                            {/* {t('Billing Rate')} */}
                            {getValueFromResource('Billing Rate',dispatch, t)}
                            {sortColumn === '5' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("desc", "5") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("asc", "5") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 5 && 
                                <><span className="cursor" onClick={() => { onHandleSorting("asc", "5") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleSorting("desc", "5") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                        </th>
                        <th style={{ width: '13%' }}
                        // onMouseEnter={() => handleMouseEnter(6)}
                        // onMouseLeave={handleMouseLeave}
                        >
                            {/* {t('Total Time')} */}
                            {getValueFromResource('Total Time',dispatch, t)}
                            {sortColumn === '6' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("desc", "6") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("asc", "6") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 6 && 
                                <><span className="cursor" onClick={() => { onHandleSorting("asc", "6") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleSorting("desc", "6") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {timeBillingWorksheetList.length > 0 && timeBillingWorksheetList.map((timeBillingObj: any, i: any) => (
                        <tr key={i}>
                            <td>
                                <div className="form-check form-switch form-check-custom">
                                    <input
                                        id="chkTimeOff"
                                        className="form-check-input h-20px w-30px"
                                        type="checkbox"
                                        checked={isItemChecked(timeBillingObj.AccountEmployeeTimeEntryId, timeBillingObj.Billed)}
                                        onChange={e => handleCheckboxChange(e, timeBillingObj.AccountEmployeeTimeEntryId)}
                                    />
                                </div>                               
                            </td>
                            <td>
                             <span style={{ color: '#7b8ba6', fontSize: 12 }} >
                                    <i className="ki-outline ki-calendar text-gray fs-5 me-2 "></i>
                                    {/* {moment.parseZone(timeBillingObj.TimeEntryDate).format('DD MMM yy')} */}
                                    {formatDateWithDateAndMonthName(timeBillingObj.TimeEntryDate, cultureInfoName.toString())}
                                </span>
                            </td>
                            <td>
                                <span className="d-block">
                                    {timeBillingObj.EmployeeName}
                                </span>                               
                            </td>
                            <td>
                                <span className="d-block">
                                    {timeBillingObj.TaskName != null ? timeBillingObj.TaskName : 'None'}
                                </span>
                                <span className="d-block">
                                    {timeBillingObj.ProjectName != null ? timeBillingObj.ProjectName : 'None'}
                                </span>
                            </td>

                            <td>
                                <span className="d-block">
                                    <div><strong>
                                        {/* {t('Invoice No:')} */}
                                        {getValueFromResource('Invoice No:',dispatch, t)}
                                        </strong> {timeBillingObj.InvoiceNumber}</div>
                                    <div><strong>
                                        {/* {t('Invoice Date:')} */}
                                        {getValueFromResource('Invoice Date:',dispatch, t)}
                                        </strong> {timeBillingObj.InvoiceDate ? formatDateWithDateAndMonthName(timeBillingObj.InvoiceDate, cultureInfoName.toString()) : ''}</div>
                                    <div><strong>
                                        {/* {t('PO Number:')} */}
                                        {getValueFromResource('PO Number:',dispatch, t)}
                                        </strong> {timeBillingObj.PONumber}</div>
                                </span>
                            </td>

                            <td>
                                <span className="d-block">
                                    {timeBillingObj.BillingRate != null ? FormatInvoiceDecimalNumber(cultureInfoName.toString(),timeBillingObj.BillingRate, decimalPlaces)  : 'None'}
                                </span>
                            </td>


                            <td>
                                <span className="d-block">
                                    {/* {timeBillingObj.TotalTime} */}
                                    {formatDateToTime(timeBillingObj.TotalTime)}
                                </span>
                            </td>

                        </tr>
                    ))}
                </tbody>
            </table>
            {timeBillingWorksheetList.length === 0 &&
                <div className=''>
                    <p className='noDataFound'>
                        {/* {t('No Record Found')} */}
                        {getValueFromResource('No Record Found',dispatch, t)}
                        </p>
                </div>
            }

        </>
    )
}

export default TimeBillingWorksheetItem
